import * as React from 'react';

export interface ILabelProps {
  label: string;
  labelFor: string;
  required?: boolean;
  className?: string;
}

export const Label = ({ label, labelFor, required, className = '' }: ILabelProps) => (
  <label className={`${className || ''} form-label`} htmlFor={labelFor}>
    {label}
    {required ? <em className='req ml-2'>*</em> : ''}
  </label>
);
